<template>
  <v-layout column>
    <v-flex>
      <lookup-select
        label="Destination"
        v-model="item.verificationdestinationid"
        lookup-name="VerificationDestination"
      />
    </v-flex>
    <v-flex>
      <lookup-select
        label="Scope of Practice"
        v-model="item.scopeofpracticeid"
        lookup-name="ScopesOfPractice"
      />
    </v-flex>
    <v-flex>
      <v-layout>
        <v-flex>
          <date-picker
            v-model="item.verificationrequestdate"
            label="Request Date"
          />
        </v-flex>
        <v-flex>
          <v-text-field
            type="number"
            v-model="item.registrationyear"
            label="Registration Year"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout>
        <v-flex>
          <v-checkbox v-model="item.ingoodstanding" label="In Good Standing?" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "VerificationsForm",
  props: {
    item: Object,
    required: true
  },
  created() {
    this.item.verificationrequestdate =
      this.item.verificationrequestdate || new Date();

    this.item.registrationyear =
      this.item.registrationyear || this.$moment().format("YYYY");
  }
};
</script>
